import BeatLoader from "react-spinners/BeatLoader"

export default function ButtonLoading() {
	return <BeatLoader color="white" />
}
